function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Clock Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M9.015,0.5 C13.7188067,0.5 17.532,4.31352189 17.532,9.017 C17.532,13.7203066 13.7189781,17.533 9.015,17.533 C4.31269335,17.533 0.5,13.7199781 0.5,9.017 C0.5,4.31385049 4.31286474,0.5 9.015,0.5 Z M9.015,1.5 C4.86520737,1.5 1.5,4.86607738 1.5,9.017 C1.5,13.1677126 4.86499739,16.533 9.015,16.533 C13.1667126,16.533 16.532,13.1680026 16.532,9.017 C16.532,4.86578735 13.1665026,1.5 9.015,1.5 Z M9.03414428,4.5526999 C9.31028411,4.55388885 9.53317965,4.77870444 9.53199988,5.05484428 L9.51412362,9.22212443 L6.38865276,12.4031266 C6.19511749,12.6001005 5.87854727,12.602888 5.68157339,12.4093528 C5.48459951,12.2158175 5.48181197,11.8992473 5.67534724,11.7022734 L8.51587638,8.81127557 L8.53199988,5.05055572 C8.53318885,4.77441589 8.75800444,4.55152035 9.03414428,4.5526999 Z",
  id: "clock-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "clock-Icon/Global/clock-requests",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "clock-Swatches/DarkGreen",
  transform: "translate(3.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "clock-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#clock-path-1"
})));

var SvgClock = function SvgClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock.eb8b3c77.svg";
export { ForwardRef as ReactComponent };